import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { unpack_validation } from 'z3k-parser/validation/types';
import { useBox } from 'shared/hooks/utils';
import { Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
import { useBooleanState } from 'shared/hooks/state/boolean';
export function GuardZonesList() {
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const { addIdToBlacklist, sendCommand } = useContext(Z3KSettings);
    const configBox = useBox(config);
    const [allowAddKeys, , , toggleAllowAddKeys] = useBooleanState(false);
    const onSendAddCommand = useCallback(() => {
        sendCommand(null, 'AllowTMKeysAdd', {
            shouldAllow: !allowAddKeys,
        });
        toggleAllowAddKeys();
    }, [allowAddKeys, sendCommand, toggleAllowAddKeys]);
    const mainTitleComponentRender = useCallback(() => (_jsx(Box, { display: "flex", justifyContent: "center", p: 1, children: _jsxs(Button, { variant: "contained", color: "primary", onClick: onSendAddCommand, startIcon: _jsx(Add, {}), sx: { whiteSpace: 'normal' }, children: [!allowAddKeys ? 'Разрешить' : 'Отменить', " \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043B\u044E\u0447\u0435\u0439"] }) })), [onSendAddCommand, allowAddKeys]);
    const onDeleteTMKey = useCallback((object, new_list) => {
        addIdToBlacklist(object.id);
        replace_config({
            ...findAndChangeLinks(configBox.current, object.id),
            tm_keys: new_list,
        });
        sendCommand(object.id, 'RemoveObject', null);
    }, [sendCommand, addIdToBlacklist, replace_config]);
    const childrenItem = (selected_item_id) => {
        return (_jsxs(_Fragment, { children: [_jsx(DragDropDrawer, { z3k_name: "guard_zones", help_id: "guard_zones", item_url: Z3kSecondRoutes.zone, name: RouteNaming[Z3kSecondRoutes.zone], enableDnd: true, selected_item_id: selected_item_id }), _jsx(DragDropDrawer, { z3k_name: "tm_keys", help_id: "tm_keys", item_url: Z3kSecondRoutes.tm_keys, name: RouteNaming[Z3kSecondRoutes.tm_keys], hideAddButton: true, onDelete: onDeleteTMKey, mainTitleComponentRender: mainTitleComponentRender, selected_item_id: selected_item_id })] }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
const fields = ['guard_zones', 'tm_keys'];
GuardZonesList.isError = (validation_result) => fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
GuardZonesList.isWarning = GuardZonesList.isError;
GuardZonesList.isShown = (is_service_view, config, spec, is_staff, is_climatic) => is_service_view &&
    !is_climatic &&
    (spec.has_guard_zones || spec.io.has_buzzers || spec.io.has_guard_indicators);
